import EventOccurenceModelBase from '../_generated/modelBases/event-occurence-model-base';

export default class EventOccurenceModel extends EventOccurenceModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
